import {
  formatName,
  getClinic,
  type ScheduleOverrideWithRelations,
  type StaffMember,
} from '@snootsvet/shared'

import { Button } from '@/frontend/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/frontend/components/ui/table'

interface Props {
  overrides: ScheduleOverrideWithRelations[]
  /** Resolves an override's `createdBy` staff id to a member for the "Created by" column. */
  staffById: Map<string, StaffMember>
  onEdit: (override: ScheduleOverrideWithRelations) => void
  onDelete: (override: ScheduleOverrideWithRelations) => void
}

/** List view of one-off shifts, with edit/delete actions per row. */
export function ScheduleOverridesTable({ overrides, staffById, onEdit, onDelete }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Date</TableHead>
          <TableHead>Vet</TableHead>
          <TableHead>Clinic</TableHead>
          <TableHead>Template</TableHead>
          <TableHead>Note</TableHead>
          <TableHead>Created by</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {overrides.map((o) => {
          const creator = o.createdBy ? staffById.get(o.createdBy) : undefined
          return (
            <TableRow key={o.id}>
              <TableCell>{o.date}</TableCell>
              <TableCell>{formatName(o.staff)}</TableCell>
              <TableCell>{getClinic(o.clinicId)?.name ?? o.clinicId}</TableCell>
              <TableCell className="text-muted-foreground text-sm">{o.template.name}</TableCell>
              <TableCell>{o.note ?? '—'}</TableCell>
              <TableCell className="text-muted-foreground text-sm">
                {creator ? formatName(creator) : '—'}
              </TableCell>
              <TableCell>
                <div className="flex gap-1">
                  <Button variant="ghost" onClick={() => onEdit(o)}>
                    Edit
                  </Button>
                  <Button variant="ghost-destructive" onClick={() => onDelete(o)}>
                    Delete
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
